// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"_ae5fd2a","inputColumnWrapper":"_e9a41bc","button":"_51a1521","first":"_3c9bb8f","paragraph":"_04779c1"};